import {gql} from "@irati/utils/gql"

import Step from "./tenantOnboardingStep"

const fragment = gql`
  fragment TenantOnboarding on TenantOnboarding {
    uuid
    businessId
    tenant {
      public_name
      subdomain
    }
    enabled
    preOnboardingFinished
    onboardingFinished
    metadata {
      createdAt
    }
    assignedSteps {
      ...TenantOnboardingStep
    }
  }
  ${Step}
`

export default fragment
